import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SvgIconName } from '../svg-icon/svg-icon-name';
import { DoubleTapDirective } from '../directives/doubletap.directive';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-tile-button',
  templateUrl: './tile-button.component.html',
  styleUrls: [ './tile-button.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DoubleTapDirective,
    SvgIconComponent,
  ],
})
export class TileButtonComponent {
  public readonly icon = input<SvgIconName>();
  public readonly imageUrl = input<string>();
  public readonly text = input.required<string>();
  public readonly active = input<boolean>();

  public readonly click = output();
  public readonly dblclick = output();

  public onButtonClick(event: MouseEvent) {
    event.stopPropagation();
    this.click.emit();
  }

  public onButtonDoubleClick(event: MouseEvent) {
    event.stopPropagation();
    this.dblclick.emit();
  }
}
